import { render, staticRenderFns } from "./promotion-form.vue?vue&type=template&id=ad6804dc"
import script from "./promotion-form.vue?vue&type=script&lang=js"
export * from "./promotion-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports